import React from 'react';
import { connect } from 'react-redux';
import { attachDefaultUnits } from '../../redux/selectors/points';
import { unique, groupListByProperty } from '../../utils/collections';
import PointTrendContainer from '../trends/PointTrendContainer';
import EquipmentLoader from '../loaders/EquipmentLoader';

const PointTrendsByUnit = ({
  buildingsById,
  pointCount,
  equipCount,
  measurements,
  trendsByMeasurement,
  trendsByPointType,
}) => (
  <div style={{ width: '100%' }}>
    Buildings: {Object.keys(buildingsById).length} <br />
    Points: {pointCount} <br />
    Equipment: {equipCount} <br />
    <br />
    {Object.keys(buildingsById).map((bid) => (
      // EquipmentLoader also loads points
      <EquipmentLoader key={bid} buildingId={bid} getDevices />
    ))}
    {measurements.map(({ id, name }) => (
      <PointTrendContainer
        key={id}
        title={`Sensors measuring ${name}`}
        pointIds={trendsByMeasurement[id]}
        includeEquip
      />
    ))}
    {Object.entries(trendsByPointType).map(([pt, points]) => (
      <PointTrendContainer
        key={pt}
        title={`Sensors measuring ${pt}`}
        pointIds={points}
        includeEquip
      />
    ))}
  </div>
);

export default connect((state, { pointIds }) => {
  const {
    entities: {
      points: { byId: pById },
      pointTypes: { byId: ptById },
      measurements: { byId: measById },
    },
  } = state;
  const points = pointIds.map((p) => pById[p]).filter(Boolean);
  const pointsWithUnits = attachDefaultUnits(state, points);
  const pointsByUnit = groupListByProperty('defaultUnit', pointsWithUnits);

  // show sensors with the same measurement in a graph together
  // except for 'Ordinal', which measures lots of different stuff and should be separated
  const trendsByMeasurement = pointsWithUnits
    .filter((p) => p.defaultUnit !== 'Ordinal')
    .reduce((map, p) => {
      const pointType = ptById[p.pointTypeId];
      const measurementId = pointType?.measurementId;
      if (measurementId != null) {
        const current = map[measurementId] || [];
        current.push(p.id);
        // eslint-disable-next-line no-param-reassign
        map[measurementId] = current;
      }
      return map;
    }, {});
  const measurements = Object.keys(trendsByMeasurement)
    .map((id) => measById[id])
    .filter((m) => m != null);

  // Here we handle the ordinal units, splitting them by point type (more finely than measurement)
  const trendsByPointType = (pointsByUnit.Ordinal || []).reduce((obj, point) => {
    const key = ptById[point.pointTypeId].name;
    const entry = obj[key] || [];
    entry.push(point.id);
    // eslint-disable-next-line no-param-reassign
    obj[key] = entry;
    return obj;
  }, {});

  return {
    pointCount: points?.length,
    equipCount: unique(points.flatMap((p) => p.equipIds)).length,
    measurements,
    trendsByMeasurement,
    trendsByPointType,
  };
})(PointTrendsByUnit);
